document.addEventListener("DOMContentLoaded", () => {
  const formatMoney = (cents, currency) => {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-IN", {
        style: "currency",
        currency: currency || "INR"
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)}`;
    }
  };

  const getVariantInventoryLimit = (variant) => {
    if (!variant || !variant.available) return 0;
    if (variant.inventory_management && variant.inventory_policy !== "continue") {
      if (!Object.prototype.hasOwnProperty.call(variant, "inventory_quantity")) return null;
      return Math.max(0, Number(variant.inventory_quantity || 0));
    }
    return null;
  };

  const updateQuantityControl = (quantity, variant, showLimitMessage = false) => {
    const input = quantity.querySelector("[data-qty-input]");
    const display = quantity.querySelector("[data-qty-display]");
    const minus = quantity.querySelector("[data-qty-minus]");
    const plus = quantity.querySelector("[data-qty-plus]");
    const message = quantity.querySelector("[data-stock-message]");
    const limit = getVariantInventoryLimit(variant);

    if (!input || !display || !minus || !plus) return;

    let value = Math.max(1, Number(input.value || 1));

    if (limit !== null && limit > 0 && value > limit) {
      value = limit;
    }

    if (limit === 0) {
      value = 1;
    }

    input.value = String(value);
    display.textContent = String(value);
    input.setAttribute("max", limit === null ? "" : String(Math.max(1, limit)));

    minus.disabled = value <= 1 || limit === 0;
    plus.disabled = limit !== null && value >= limit;

    if (message) {
      const shouldShow = showLimitMessage && limit !== null && limit > 0 && value >= limit;
      message.hidden = !shouldShow;
      message.textContent = shouldShow ? `Only ${limit} pieces available.` : "";
    }
  };

  const initQuantityControl = (quantity, getVariant) => {
    const input = quantity.querySelector("[data-qty-input]");
    const minus = quantity.querySelector("[data-qty-minus]");
    const plus = quantity.querySelector("[data-qty-plus]");

    if (!input || !minus || !plus) return;

    minus.addEventListener("click", () => {
      input.value = String(Math.max(1, Number(input.value || 1) - 1));
      updateQuantityControl(quantity, getVariant());
    });

    plus.addEventListener("click", () => {
      const variant = getVariant();
      const limit = getVariantInventoryLimit(variant);
      const nextValue = Number(input.value || 1) + 1;
      const exceedsLimit = limit !== null && nextValue > limit;

      if (exceedsLimit) {
        input.value = String(Math.max(1, limit));
      } else {
        input.value = String(nextValue);
      }

      updateQuantityControl(quantity, variant, exceedsLimit);
    });

    updateQuantityControl(quantity, getVariant());
  };

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mediaItems = Array.from(gallery.querySelectorAll("[data-product-media-item]"));
    const thumbs = Array.from(gallery.querySelectorAll("[data-product-thumb]"));
    const mediaStage = gallery.querySelector("[data-product-media-stage]");
    let activeIndex = Math.max(0, mediaItems.findIndex((item) => item.classList.contains("is-active")));
    let touchStartX = 0;
    let touchStartY = 0;
    let isTransitioning = false;
    const transitionDuration = 320;

    const waitForMediaTransition = () => new Promise((resolve) => {
      window.setTimeout(resolve, transitionDuration);
    });

    const pauseInactiveVideos = () => {
      mediaItems.forEach((item) => {
        if (item.classList.contains("is-active")) return;

        item.querySelectorAll("video").forEach((video) => {
          video.pause();
        });
      });
    };

    const commitMedia = (index) => {
      if (!mediaItems.length) return false;

      activeIndex = (index + mediaItems.length) % mediaItems.length;
      const activeItem = mediaItems[activeIndex];
      const mediaId = activeItem.dataset.mediaId;

      mediaItems.forEach((item) => {
        const active = item === activeItem;
        item.classList.toggle("is-active", active);
        item.hidden = !active;
      });

      thumbs.forEach((thumb) => {
        thumb.classList.toggle("is-active", thumb.dataset.mediaId === mediaId);
      });

      pauseInactiveVideos();
      return true;
    };

    const showMedia = async (index, animate = true) => {
      if (!mediaItems.length || isTransitioning) return;

      const nextIndex = (index + mediaItems.length) % mediaItems.length;

      if (nextIndex === activeIndex && mediaItems[activeIndex].classList.contains("is-active")) {
        commitMedia(nextIndex);
        return;
      }

      if (!animate || !mediaStage || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        commitMedia(nextIndex);
        return;
      }

      isTransitioning = true;
      mediaStage.classList.remove("is-ready");
      mediaStage.classList.add("is-changing");

      await waitForMediaTransition();
      commitMedia(nextIndex);

      window.requestAnimationFrame(() => {
        mediaStage.classList.remove("is-changing");
        mediaStage.classList.add("is-ready");

        window.setTimeout(() => {
          isTransitioning = false;
        }, transitionDuration);
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const targetIndex = mediaItems.findIndex((item) => item.dataset.mediaId === thumb.dataset.mediaId);
        if (targetIndex >= 0) showMedia(targetIndex);
      });
    });

    const previousButton = gallery.querySelector("[data-product-gallery-prev]");
    const nextButton = gallery.querySelector("[data-product-gallery-next]");

    if (previousButton) {
      previousButton.addEventListener("click", () => {
        showMedia(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        showMedia(activeIndex + 1);
      });
    }

    gallery.addEventListener("touchstart", (event) => {
      if (!event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    gallery.addEventListener("touchend", (event) => {
      if (!event.changedTouches.length || mediaItems.length < 2) return;

      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY)) return;

      showMedia(activeIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    gallery.rudraShowMedia = (mediaId) => {
      const targetIndex = mediaItems.findIndex((item) => item.dataset.mediaId === String(mediaId));
      if (targetIndex >= 0) showMedia(targetIndex);
    };

    commitMedia(activeIndex);
  });

  const lightbox = document.querySelector("[data-product-lightbox]");
  const lightboxImage = document.querySelector("[data-product-lightbox-image]");
  const lightboxCloseButton = document.querySelector("[data-product-lightbox-close]");

  document.addEventListener("click", (event) => {
    const lightboxButton = event.target.closest("[data-product-lightbox-open]");
    if (!lightbox || !lightboxImage || !lightboxButton) return;

    const src = lightboxButton.dataset.lightboxSrc;
    if (!src) return;

    lightboxImage.setAttribute("src", src);
    lightboxImage.setAttribute("alt", lightboxButton.dataset.lightboxAlt || "");
    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
  });

  if (lightbox && lightboxCloseButton) {
    lightboxCloseButton.addEventListener("click", () => {
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        lightbox.classList.remove("is-open");
        lightbox.setAttribute("aria-hidden", "true");
      }
    });
  }

  document.querySelectorAll("[data-product-section]").forEach((section) => {
    const productJson = section.querySelector("[data-product-json]");
    const variantInventoryJson = section.querySelector("[data-variant-inventory-json]");
    const form = section.querySelector("[data-product-form]");
    const variantInput = section.querySelector("[data-variant-id]");
    const priceElement = section.querySelector("[data-product-price]");
    const addButton = section.querySelector("[data-add-to-cart]");
    const optionInputs = section.querySelectorAll("[data-variant-option]");
    const quantity = section.querySelector(".rudra-quantity");
    const stockMessage = section.querySelector("[data-stock-message]");
    const gallery = section.querySelector("[data-product-gallery]");
    const stickyBuy = document.querySelector("[data-sticky-buy]");
    const stickyVariant = stickyBuy ? stickyBuy.querySelector("[data-sticky-variant]") : null;
    const stickyPrice = stickyBuy ? stickyBuy.querySelector("[data-sticky-price]") : null;
    const stickyAdd = stickyBuy ? stickyBuy.querySelector("[data-sticky-add]") : null;

    if (!productJson || !form) return;

    const product = JSON.parse(productJson.textContent);
    const inventoryByVariant = variantInventoryJson ? JSON.parse(variantInventoryJson.textContent) : {};

    product.variants.forEach((variant) => {
      const inventoryQuantity = inventoryByVariant[String(variant.id)];
      if (Number.isFinite(Number(inventoryQuantity))) {
        variant.inventory_quantity = Number(inventoryQuantity);
      }
    });

    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "INR";

    const getSelectedOptions = () => {
      const selected = [];
      optionInputs.forEach((input) => {
        if (input.matches("select") || input.checked) {
          selected[Number(input.dataset.optionPosition) - 1] = input.value;
        }
      });
      return selected;
    };

    const findVariant = () => {
      if (product.has_only_default_variant || !optionInputs.length) {
        return product.variants.find((variant) => String(variant.id) === String(variantInput ? variantInput.value : "")) || product.variants[0];
      }

      const selected = getSelectedOptions();
      return product.variants.find((variant) => {
        return selected.every((value, index) => variant.options[index] === value);
      });
    };

    const isCombinationAvailable = (position, value) => {
      const selected = getSelectedOptions();
      selected[position - 1] = value;

      return product.variants.some((variant) => {
        return variant.available && selected.every((selectedValue, index) => {
          return !selectedValue || variant.options[index] === selectedValue;
        });
      });
    };

    const doesCombinationExist = (position, value) => {
      const selected = getSelectedOptions();
      selected[position - 1] = value;

      return product.variants.some((variant) => {
        return selected.every((selectedValue, index) => {
          return !selectedValue || variant.options[index] === selectedValue;
        });
      });
    };

    const updateOptionAvailability = () => {
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition);

        if (input.matches("select")) {
          Array.from(input.options).forEach((option) => {
            option.disabled = !doesCombinationExist(position, option.value);
          });
          return;
        }

        const available = isCombinationAvailable(position, input.value);
        input.disabled = !available;
        const label = form.querySelector(`label[for="${input.id}"]`);

        if (label) {
          label.classList.toggle("is-disabled", !available);
        }
      });
    };

    const validateQuantity = (variant) => {
      const input = quantity ? quantity.querySelector("[data-qty-input]") : null;
      const limit = getVariantInventoryLimit(variant);
      const requested = Math.max(1, Number(input ? input.value : 1));

      if (!variant || !variant.available || limit === 0) {
        if (stockMessage) {
          stockMessage.hidden = false;
          stockMessage.textContent = "This watch is currently sold out.";
        }
        return false;
      }

      if (limit !== null && requested > limit) {
        if (input) input.value = String(limit);
        if (quantity) updateQuantityControl(quantity, variant);
        if (stockMessage) {
          stockMessage.hidden = false;
          stockMessage.textContent = `Only ${limit} pieces available.`;
        }
        return false;
      }

      return true;
    };

    const updateButtons = (variant) => {
      const available = Boolean(variant && variant.available && getVariantInventoryLimit(variant) !== 0);
      const label = available ? "Add to Cart" : "Sold Out";

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = label;
      }

      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = label;
      }
    };

    const updateProductState = () => {
      const variant = findVariant();

      if (variantInput && variant) {
        variantInput.value = variant.id;
      }

      if (priceElement && variant) {
        priceElement.textContent = formatMoney(variant.price, currency);
      }

      if (stickyVariant) {
        const shouldShowVariant = Boolean(variant && !product.has_only_default_variant && variant.title !== "Default Title");
        stickyVariant.hidden = !shouldShowVariant;
        stickyVariant.textContent = shouldShowVariant ? variant.title : "";
      }

      if (stickyPrice && variant) {
        stickyPrice.textContent = formatMoney(variant.price, currency);
      }

      if (gallery && gallery.rudraShowMedia && variant && variant.featured_media) {
        gallery.rudraShowMedia(variant.featured_media.id);
      }

      if (quantity) {
        updateQuantityControl(quantity, variant);
      }

      updateButtons(variant);
      updateOptionAvailability();
    };

    optionInputs.forEach((input) => {
      input.addEventListener("change", updateProductState);
    });

    if (quantity) {
      initQuantityControl(quantity, findVariant);
    }

    form.addEventListener("submit", (event) => {
      if (!validateQuantity(findVariant())) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    if (stickyAdd) {
      stickyAdd.addEventListener("click", () => {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else if (addButton) {
          addButton.click();
        }
      });
    }

    updateProductState();

    const recentlyViewed = JSON.parse(localStorage.getItem("rudraRecentlyViewed") || "[]");
    const productCard = {
      id: section.dataset.productId,
      handle: section.dataset.productHandle,
      title: section.dataset.productTitle,
      url: section.dataset.productUrl,
      image: section.dataset.productImage,
      price: section.dataset.productPrice
    };

    const filtered = recentlyViewed.filter((item) => item && item.id !== productCard.id);
    filtered.unshift(productCard);
    localStorage.setItem("rudraRecentlyViewed", JSON.stringify(filtered.slice(0, 8)));
  });

  document.querySelectorAll("[data-recently-viewed-section]").forEach((section) => {
    const grid = section.querySelector("[data-recently-viewed-grid]");
    const empty = section.querySelector("[data-recently-viewed-empty]");
    const currentProductId = section.dataset.currentProductId;
    const items = JSON.parse(localStorage.getItem("rudraRecentlyViewed") || "[]")
      .filter((item) => item && item.id !== currentProductId)
      .slice(0, 4);

    if (!grid) return;

    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    grid.innerHTML = "";

    items.forEach((item) => {
      const link = document.createElement("a");
      link.href = item.url;
      link.className = "rudra-card rudra-recent-card";

      if (item.image) {
        const media = document.createElement("div");
        media.className = "rudra-card__media";

        const image = document.createElement("img");
        image.src = item.image;
        image.alt = item.title;
        image.className = "rudra-card__image";
        image.loading = "lazy";
        media.appendChild(image);
        link.appendChild(media);
      }

      const content = document.createElement("div");
      content.className = "rudra-card__content";

      const meta = document.createElement("p");
      meta.className = "rudra-card__meta";
      meta.textContent = "Recently Viewed";
      content.appendChild(meta);

      const title = document.createElement("h3");
      title.textContent = item.title;
      content.appendChild(title);

      const price = document.createElement("p");
      price.className = "rudra-card__price";
      price.textContent = item.price || "";
      content.appendChild(price);

      const cta = document.createElement("span");
      cta.className = "rudra-card__button";
      cta.textContent = "View Watch";
      content.appendChild(cta);

      link.appendChild(content);
      grid.appendChild(link);
    });
  });
});
